import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import { Facebook, Twitter, Instagram, LinkedIn, LocationOn, Phone, Email } from "@mui/icons-material";
// import { Link as RouterLink } from "react-router-dom";
import "./Style.css";
import Logo from '../assets/Logos/TNG_global_v2-04.png';

function Footer() {
  return (
    <Box id="footer">
      <Grid container spacing={6} className="footer-container">
        {/* Left Column */}
        <Grid item xs={12} sm={6}>
          <img
            src={Logo}
            alt="Logo"
            className="footer-logo"
          />
          <Typography variant="body2" className="footer-text">
            Explore the world with <b>TNG Global!</b> <br/>
            We bring you personalized,
            hassle-free travel experiences, covering everything from adventure
            tours to luxurious getaways.
          </Typography>
          <Box className="social-icons">
            <Facebook />
            <Twitter />
            <Instagram />
            <LinkedIn />
          </Box>
        </Grid>

        {/* Get In Touch */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" className="footer-title">
            Get In Touch
          </Typography>

          <Box className="contact-card">
            <LocationOn className="contact-icon" />
            <Typography variant="body2">155 Willowbrook Blvd, Ste 110 #7333, Wayne, New Jersey 07470 USA</Typography>
          </Box>

          <Box className="contact-card">
            <Phone className="contact-icon" />
            <Link href="tel:+18882448864" className="contact-link">+1 888 244 8864</Link>
          </Box>

          <Box className="contact-card">
            <Email className="contact-icon" />
            <Link href="mailto:info@tng.global" className="contact-link">info@tng.global</Link>
          </Box>
        </Grid>
      </Grid>

      <Typography variant="body2" className="footer-copyright">
        © {new Date().getFullYear()} <strong>TNG Global</strong>, All Rights Reserved.
      </Typography>
    </Box>

  );
}

export default Footer;
